import { useCallback, useState } from "react";
import { useLocation } from "react-router-dom";
import Accordion from "../widgets/Accordion";
import ChoiceGroup from "../forms/ChoiceGroup";
import { useSellerState } from "../../js/state/sellerState";
import { useAutosave } from "../../js/hooks/useAutosave";
import { useGuestMode } from "../../js/hooks/useGuestMode";
import { TIPS } from "../../pages/seller/SellerTips";
import { parseFilmSearch } from "@tour/film.js";

export default function SellerTipsPanel() {
  const { search } = useLocation();
  const filmOn = parseFilmSearch(search).on;
  const { seller, updatePortfolio } = useSellerState();
  const { canPersist } = useGuestMode();
  const [form, setForm] = useState({
    acknowledged: seller.portfolio.tips?.acknowledged || "",
  });

  const persist = useCallback(
    (next) => {
      if (!canPersist) return;
      updatePortfolio("tips", next);
    },
    [canPersist, updatePortfolio]
  );

  useAutosave(canPersist ? form : null, persist);

  return (
    <div className="sidebar-panel">
      <h3 className="sidebar-panel__title">Seller tips</h3>
      <p className="muted sidebar-panel__lead">Legal, calm guidance. The portfolio on the right does not change.</p>
      <Accordion items={TIPS} startClosed={filmOn} />
      <ChoiceGroup
        label="I have reviewed these tips"
        name="acknowledged"
        value={form.acknowledged}
        onChange={(event) => setForm({ acknowledged: event.target.value })}
        options={[
          { value: "yes", label: "Yes, I have read them" },
          { value: "later", label: "I will come back" },
        ]}
      />
    </div>
  );
}
